export const APP_NAME = "Beta Chat";

// export const API_URL = "https://connect.yuukke.betalearnings.com/bca/";
//export const BASE_URL = "https://bml.betalearnings.com/";
//export const API_URL = "https://iwn.betalearnings.com/peersquare/";
//export const BASE_URL = "https://iwn.betalearnings.com/";k
// export const BASE_URL = "http://localhost:3000/";
// export const API_URL = "http://localhost:8081/";
export const API_URL = "https://betachat.betalearnings.com/bcav1/";
// export const API_URL = "https://corporate.yuukke.com/bcav2/";
// export const API_URL = "http://localhost:8082/bcav2/";
// export const API_URL = "https://bmlv2.betalearnings.com/bcav2/";// export const API_URL = "https://betachat.betalearnings.com/bcav1/";/

// export const API_URL = "https://ycom.betalearnings.com/bcav1/";

export const TEAMS_SSO_URL = "https://testapi.betalearnings.com/";
export const HTTP_HEADERS = {
  "Content-Type": "application/json",
  //  Authorization: "PEERSQAURE-JWT",
};

export const profiles = "moodle,keycloak";

// CHAT NEEDS

// TEST
//export const CHAT_URL = "https://chat.yuukke.betalearnings.com"
// export const JITSI_URL = "http://meet.yuukke.org/";

// LOCAL
// export const CHAT_URL = "https://chat.yuukke.betalearnings.com/";
// export const JITSI_URL = "http://meeting.jitsi.betalearnings.com/"

// export const CHAT_URL = "https://ycom.betalearnings.com/chat/";
// export const JITSI_URL = "http://localhost:3001/";

// Ycom Server

// export const BASE_URL = "https://hub.yalamanchili.in/";
// export const BASE_URL = "http://localhost:3000/";
export const BASE_URL = "https://betachat.betalearnings.com/"
// export const API_URL = "https://ycom.betalearnings.com/bcav1/";
export const CHAT_URL = "https://betachat.betalearnings.com/chat/";
// export const JITSI_URL = "https://jitsimeet.ycom.betalearnings.com/";
export const JITSI_URL = "https://jitsimeetv1.betalearnings.com/";
// export const SOCKET_URL = "https://chat.betachat.betalearnings.com/";
export const SOCKET_URL = "https://socket.betalearnings.com/";
// export const CHAT_URL = "http://localhost:5000/";

// export const JITSI_URL = "https://ycom.betalearnings.com/meet/";
